import { FC } from 'react';

// https://dev.to/
const About: FC = () => {
  return (
    <svg
      viewBox="0 0 235 234"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMinYMin meet"
    >
      <g fill="none" fillRule="evenodd">
        <path fill="#88AEDC" d="M234.04 175.67l-75.69 58.28h47.18L234.04 212z"></path>
        <path d="M234.04 140.06l-121.93 93.89h.02l121.91-93.87zM133.25.95L.04 103.51v.02L133.27.95z"></path>
        <path fill="#F58F8E" fillRule="nonzero" d="M.04.95v30.16L39.21.95z"></path>
        <path fill="#FEE18A" fillRule="nonzero" d="M39.21.95L.04 31.11v35.9L85.84.95z"></path>
        <path fill="#F3F095" fillRule="nonzero" d="M85.84.95L.04 67.01v36.5L133.25.95z"></path>
        <path fill="#55C1AE" fillRule="nonzero" d="M133.27.95L.04 103.53v35.59L179.49.95z"></path>
        <path
          fill="#F7B3CE"
          fillRule="nonzero"
          d="M234.04.95h-7.37L.04 175.45v35.93l234-180.18z"
        ></path>
        <path fill="#88AEDC" fillRule="nonzero" d="M179.49.95L.04 139.12v36.33L226.67.95z"></path>
        <path
          fill="#F58F8E"
          fillRule="nonzero"
          d="M234.04 31.2L.04 211.38v22.57h18.03l215.97-166.3z"
        ></path>
        <path
          fill="#FEE18A"
          fillRule="nonzero"
          d="M234.04 67.65L18.07 233.95H64.7l169.34-130.39z"
        ></path>
        <path
          fill="#F3F095"
          fillRule="nonzero"
          d="M234.04 103.56L64.7 233.95h47.41l121.93-93.89z"
        ></path>
        <path
          fill="#55C1AE"
          fillRule="nonzero"
          d="M234.04 140.08l-121.91 93.87h46.22l75.69-58.28z"
        ></path>
        <path fill="#F7B3CE" fillRule="nonzero" d="M234.04 212l-28.51 21.95h28.51z"></path>
        <path
          d="M65.237 77.75c4.514.95 7.774 2.8 11.135 6.3 3.059 3.2 4.965 6.85 5.767 10.95.652 3.45.652 40.55 0 44.05-1.705 9.1-9.479 16.2-19.109 17.45-2.006.25-8.727.5-14.845.5H37V77h12.438c8.828 0 13.342.2 15.8.75zM51.545 117v25.6l5.166-.2c4.464-.15 5.417-.35 7.423-1.5 3.912-2.3 3.962-2.45 3.962-24.2 0-21.2 0-21.2-3.661-23.6-1.806-1.2-2.558-1.35-7.473-1.55l-5.417-.15V117zm79.245-32.75v7.25h-25.58v18h15.549V124H105.21l.1 9.1.15 9.15 12.69.15 12.638.1V157h-14.795c-16.451 0-19.009-.3-21.617-2.6-3.661-3.2-3.46-1.15-3.611-36.3-.1-21.9.05-32.25.401-33.65.702-2.6 3.661-5.8 6.27-6.7 1.554-.55 5.466-.7 17.704-.75h15.648v7.25zm31.647 20.85c3.712 14.25 6.821 25.6 6.922 25.25.15-.35 3.31-12.4 7.071-26.85l6.872-26.25 7.824-.15c5.918-.1 7.874.05 7.874.5s-17.354 66.2-18.357 69.5c-.702 2.3-4.463 7-6.57 8.25-2.658 1.5-6.57 1.75-8.978.5-2.156-1.1-5.015-4.4-6.47-7.5-.902-1.9-15.648-56-19.058-70l-.352-1.35h7.825c7.673 0 7.874 0 8.275 1.1.2.65 3.41 12.8 7.122 27z"
          fill="#FFF"
        ></path>
      </g>
    </svg>
  );
};

export default About;
